import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  title: {
    fontSize: '25px',
    fontWeight: '600',
    margin: '10px 0px',
    lineHeight: 1,
    color: 'white',
  }
}));